// AXIOS
import axios from "axios";

// api url
import { apiUrl_forCategories, apiUrl_forImages } from "./constants";

// cancel token
const CancelToken = axios.CancelToken;

// get categories
export let cancelGetCategoriesApi;
export async function getCategories(headers, query = "") {
    if (headers) {
        const categories = await axios.get(
            apiUrl_forCategories + "categories?" + query,
            {
                headers: { ...headers },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelGetCategoriesApi = c;
                }),
            }
        );
        return categories;
    } else {
        console.log("Please add required parameters");
    }
}

// get categories tree
export let cancelGetCategoriesTreeApi;
export async function getCategoriesTree(headers) {
    if (headers) {
        const categoriesTree = await axios.get(
            apiUrl_forCategories + "categories/tree",
            {
                headers: { ...headers },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelGetCategoriesTreeApi = c;
                }),
            }
        );
        return categoriesTree;
    } else {
        console.log("Please add required parameters");
    }
}

// add category
export let cancelAddCategoryApi;
export async function addCategory(headers, categoryData) {
    if (headers && categoryData) {
        const emails = await axios.post(
            apiUrl_forCategories + "category",
            {
                category_name: categoryData.category_name,
                parent_id: categoryData.parent_id,
                status: categoryData.status,
                description: categoryData.description,
                meta_title: categoryData.meta_title,
                meta_keywords: categoryData.meta_keywords,
                meta_description: categoryData.meta_description,
            },
            {
                headers: { ...headers },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelAddCategoryApi = c;
                }),
            }
        );
        return emails;
    } else {
        console.log("Please add required parameters");
    }
}

// add category
export let cancelSaveCategoryImageApi;
export async function saveCategoryImageApi(headers, { categoryId, image }) {
    if (headers && categoryId && image) {
        let formData = new FormData();
        formData.append("images[]", image, image.name);

        const emails = await axios.post(
            apiUrl_forImages + "categories/" + categoryId,
            formData,
            {
                headers: { ...headers },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelSaveCategoryImageApi = c;
                }),
            }
        );
        return emails;
    } else {
        console.log("Please add required parameters");
    }
}

// get category details
export let cancelGetCategoryDetailsApi;
export async function getCategoryDetails(headers, catId) {
    if (headers && catId) {
        const categories = await axios.get(
            apiUrl_forCategories + "category/" + catId,
            {
                headers: { ...headers },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelGetCategoryDetailsApi = c;
                }),
            }
        );
        return categories;
    } else {
        console.log("Please add required parameters");
    }
}

// add category
export let cancelEditCategoryApi;
export async function editCategory(headers, categoryData) {
    if (headers && categoryData) {
        const emails = await axios.put(
            apiUrl_forCategories + "category/" + categoryData.category_id,
            {
                category_name: categoryData.category_name,
                status: categoryData.status,
                description: categoryData.description,
                parent_id: categoryData.parent_id,
                meta_title: categoryData.meta_title,
                meta_keywords: categoryData.meta_keywords,
                meta_description: categoryData.meta_description,
            },
            {
                headers: { ...headers },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelEditCategoryApi = c;
                }),
            }
        );
        return emails;
    } else {
        console.log("Please add required parameters");
    }
}

// delte category
export let cancelDeleteCategoryApi;
export async function deleteCategory(headers, catId) {
    if (headers && catId) {
        const categories = await axios.delete(
            apiUrl_forCategories + "category/" + catId,
            {
                headers: { ...headers },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelDeleteCategoryApi = c;
                }),
            }
        );
        return categories;
    } else {
        console.log("Please add required parameters");
    }
}
